import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromRoot from '../../reducers';
import * as fromReset from './password-reset.reducer';
import * as fromAuth from './auth.reducer';
import * as fromResetPage from './password-reset-page.reducer';
import * as fromRequestResetPage from './request-password-reset-page.reducer';
import * as fromLoginPage from './login-page.reducer';
import * as fromRegistration from './registration.reducer';
import * as fromRegistrationPage from './registration-page.reducer';

export interface AuthState {
    user: fromAuth.State;
    loginPage: fromLoginPage.State;
}

export interface PasswordResetState {
    passwordReset: fromReset.State;
    passwordResetPage: fromResetPage.State;
    requestPasswordResetPage: fromRequestResetPage.State;
}

export interface RegistrationState {
    registration: fromRegistration.State;
    registrationPage: fromRegistrationPage.State;
}

// extend root state
export interface State extends fromRoot.State {
    auth: AuthState;
    passwordReset: PasswordResetState;
    registration: RegistrationState;
}

export const authReducers: ActionReducerMap<AuthState> = {
    user: fromAuth.reducer,
    loginPage: fromLoginPage.reducer,
};

export const passwordResetReducers: ActionReducerMap<PasswordResetState> = {
    passwordReset: fromReset.reducer,
    passwordResetPage: fromResetPage.reducer,
    requestPasswordResetPage: fromRequestResetPage.reducer
};

export const registrationReducers: ActionReducerMap<RegistrationState> = {
    registration: fromRegistration.reducer,
    registrationPage: fromRegistrationPage.reducer
};

export const selectAuthState = createFeatureSelector<AuthState>('auth');
export const selectPasswordResetState = createFeatureSelector<PasswordResetState>('passwordReset');
export const selectRegistrationState = createFeatureSelector<RegistrationState>('registration');

// user related
export const selectAuthUserState = createSelector(selectAuthState, (state: AuthState) => state.user);

export const getIsLoggedIn = createSelector(selectAuthUserState, fromAuth.getIsLoggedIn);
export const getUser = createSelector(selectAuthUserState, fromAuth.getUser);
export const getRedirectUrl = createSelector(selectAuthUserState, fromAuth.getRedirectUrl);
export const getAuthIsPending = createSelector(selectAuthUserState, fromAuth.getIsPending);

// reset related
export const selectPasswordResetUserState = createSelector(selectPasswordResetState, (state: PasswordResetState) => state.passwordReset);

export const getResetIsPending = createSelector(selectPasswordResetUserState, fromReset.getIsPending);

// registration relateds

export const selectRegistrationUserState = createSelector(selectRegistrationState, (state: RegistrationState) => state.registration);

export const getRegistrationIsPending = createSelector(selectRegistrationUserState, fromRegistration.getIsPending);

// page related
export const selectLoginPageState = createSelector(selectAuthState, (state: AuthState) => state.loginPage);
export const selectRequestPasswordResetPageState =
    createSelector(selectPasswordResetState, (state: PasswordResetState) => state.requestPasswordResetPage);
export const selectPasswordResetPageState =
    createSelector(selectPasswordResetState, (state: PasswordResetState) => state.passwordResetPage);
export const selectRegistrationPageState =
    createSelector(selectRegistrationState, (state: RegistrationState) => state.registrationPage);

export const getLoginAuthError = createSelector(selectLoginPageState, fromLoginPage.getAuthError);

export const getRequestPasswordResetError = createSelector(selectRequestPasswordResetPageState, fromRequestResetPage.getAuthError);
export const getRequestPasswordResetSuccessful =
    createSelector(selectRequestPasswordResetPageState, fromRequestResetPage.getRequestResetSuccessful);

export const getPasswordResetError = createSelector(selectPasswordResetPageState, fromResetPage.getAuthError);
export const getPasswordResetSuccessful = createSelector(selectPasswordResetPageState, fromResetPage.getResetSuccessful);

export const getRegistrationError = createSelector(selectRegistrationPageState, fromRegistrationPage.getAuthError);
export const getRegistrationSuccessful = createSelector(selectRegistrationPageState, fromRegistrationPage.getRegistrationSuccessful);
